export enum PageType {
    HOME = 'Home',
    LISTING = 'Listing',
    PDP = 'PDP',
    LOGIN = 'Login',
    SIGN_UP_ECOM = 'Sign-Up Ecom',
    BLOG = 'Blog',
    SEARCH_RESULTS = 'Search Results',
    CART = 'Cart',
    CHECKOUT = 'Checkout',
    TYP = 'TYP',
    MY_ACCOUNT = 'MyAccount',
    MY_PROFILE = 'MyProfile',
    LOYALTY = 'Loyalty',
    WISHLIST = 'Wishlist',
    OTHER = 'Other',
    PAGE_TYPE_NOT_LOADED = 'PageTypeNotLoaded'
}

export enum GtmEvents {
    SELECT_ITEM = 'select_item_new',
    VIEW_CART = 'view_cart_new',
    ADD_TO_CART = 'add_to_cart_new',
    REMOVE_FROM_CART = 'remove_from_cart_new',
    VIEW_ITEM_LIST = 'view_item_list_new',
    VIEW_ITEM = 'view_item_new',
    BEGIN_CHECKOUT = 'begin_checkout_new',
    PURCHASE = 'purchase_new',
    LOGIN = 'login_new',
    USER_DATA = 'user_data_new',
    ADD_TO_WISHLIST = 'add_to_wishlist_new',
    ADD_SHIPPING_INFO = 'add_shipping_info_new',
    CHECKOUT_ADD_ADDRESS_INFO = 'checkout_step1_address',
    CHECKOUT_ADD_DELIVERY_INFO = 'checkout_step2_delivery',
    CHECKOUT_ADD_INVOICE_INFO = 'checkout_step3_invoice',
    CHECKOUT_ADD_EMAIL_INFO = 'checkout_step4_email',
    CHECKOUT_ADD_PAYMENT_INFO = 'checkout_step5_payment',
    CHECKOUT_APPLE_PAY_SUCCESS = 'checkout_apple_pay_success',
    CHECKOUT_APPLE_PAY_ERROR = 'checkout_apple_pay_error',
    CHECKOUT_APPLE_PAY_CANCEL = 'checkout_apple_pay_cancel',
    CHECKOUT_GOOGLE_PAY_SUCCESS = 'checkout_google_pay_success',
    CHECKOUT_GOOGLE_PAY_CANCEL = 'checkout_google_pay_cancel',
    CHECKOUT_GOOGLE_PAY_ERROR = 'checkout_google_pay_error',
    CHECKOUT_PAYMENT_INSTRUMENT_SUCCESS = 'checkout_payment_instrument_success',
    CHECKOUT_PAYMENT_INSTRUMENT_ERROR = 'checkout_payment_instrument_error',
    CHECKOUT_PAYMENT_INSTRUMENT_CANCEL = 'checkout_payment_instrument_cancel',
    ADD_PAYMENT_INFO = 'add_payment_info_new',
    CLICK_MENU = 'click_menu_new',
    CLICK_FILTER = 'click_filter_new',
    VIEW_SEARCH_RESULT = 'view_search_results_new',
    ADD_VENCHI_MIX = 'add_venchi_mix_new',
    VCLUB_SIGNUP = 'vclub_signup_new',
    PAGE_TYPE = 'page_type'
}

export enum CheckoutType {
    GUEST_CHECKOUT = 'guest_checkout',
    CLASSIC_CHECKOUT = 'classic_checkout'
}

export enum LoginType {
    GOOGLE = 'google',
    FACEBOOK = 'fb'
}

export enum LoginFromType {
    CHECKOUT = 'checkout',
    LOGIN = 'login'
}

export enum LoginState {
    LOGGED_USER = 'logged_user',
    GUEST = 'guest'
}

export enum SessionStorageKey {
    PREV_LOGIN_STATE = 'prev_login_state',
    LOGIN_FROM = 'login_from'
}
